import { Language } from "../context/LanguageContext";

// Gizlilik Politikası, Kullanım Koşulları ve Hesap Silme sayfalarının metinleri.
// Paragraf ve maddelerde [metin](/yol) yazımı sayfa içinde link olarak gösterilir.
// Metinde değişiklik yaptığınızda LAST_UPDATED tarihini de güncelleyin.

export type LegalDocKey = "privacy" | "terms" | "accountDeletion";

export interface LegalSection {
  heading: string;
  paragraphs?: string[];
  items?: string[];
}

export interface LegalDoc {
  title: string;
  intro: string[];
  sections: LegalSection[];
}

export const LEGAL_PATHS: Record<LegalDocKey, string> = {
  privacy: "/gizlilik-politikasi",
  terms: "/kullanim-kosullari",
  accountDeletion: "/hesap-silme",
};

export const LAST_UPDATED: Record<Language, string> = {
  tr: "29 Ekim 2026",
  en: "October 29, 2026",
};

export const MIN_USER_AGE = 13;

const CONTACT_EMAIL = "support@mutfacik.com";
const CONTACT_PHONE = "+90 533 871 29 02";
const BUSINESS_PHONE = "+90 533 841 74 69";
const WEBSITE = "https://www.mutfacik.com";
const BUSINESS_OWNER = "Aydın Tuna Akyıldız";
const BUSINESS_REG_NO = "1283218125";
const BUSINESS_ADDRESS = "Mücahitler Caddesi No: 42, B1, Türk Mahallesi, Girne";

const tr: Record<LegalDocKey, LegalDoc> = {
  privacy: {
    title: "Gizlilik Politikası",
    intro: [
      "Mutfacık (\"Mutfacık\", \"biz\"), mutfacik.com web sitesi ve Mutfacık mobil uygulaması (birlikte \"Platform\") üzerinden Kuzey Kıbrıs'taki restoranlardan yemek siparişi vermenizi sağlayan bir sipariş platformudur.",
      "Bu Gizlilik Politikası; hangi kişisel verilerinizi topladığımızı, bu verileri hangi amaçlarla kullandığımızı, kimlerle paylaştığımızı, ne kadar süre sakladığımızı ve verilerinizle ilgili haklarınızı açıklar. Platformu kullanarak bu politikada anlatılan veri işleme faaliyetleri hakkında bilgilendirildiğinizi kabul etmiş olursunuz.",
    ],
    sections: [
      {
        heading: "1. Veri Sorumlusu ve İletişim",
        paragraphs: [
          `Kişisel verilerinizin sorumlusu, Mutfacık markasıyla faaliyet gösteren ${BUSINESS_OWNER}'dır (MŞ No: ${BUSINESS_REG_NO}, ${BUSINESS_ADDRESS}, Kuzey Kıbrıs).`,
          `Gizlilikle ilgili tüm soru ve talepleriniz için: E-posta: ${CONTACT_EMAIL} · Telefon: ${CONTACT_PHONE}`,
        ],
      },
      {
        heading: "2. Topladığımız Veriler ve Kullanım Amaçları",
        paragraphs: [
          "Yalnızca siparişinizi alıp size ulaştırabilmek ve hesabınızı güvenle yönetebilmek için gerekli olan verileri topluyoruz:",
        ],
        items: [
          "Ad ve soyad: Hesabınızı oluşturmak; siparişin size ait olduğunu restorana ve kuryeye göstermek ve teslimatta sizi tanıyabilmek için.",
          `Doğum tarihi: Platformu kullanmak için gereken asgari yaşı (${MIN_USER_AGE} yaş ve üzeri) doğrulamak ve yaş sınırlamasına tabi ürünlerin küçüklere satılmasını önlemek için. Doğum tarihiniz restoranlarla paylaşılmaz.`,
          "E-posta adresi: Hesabınıza giriş ve hesabınızın doğrulanması; sipariş onayı ve sipariş durumu bildirimleri; siparişinizle ilgili bir sorun olduğunda (gecikme, iptal, eksik ürün vb.) sizi bilgilendirmek; şifre sıfırlama ve güvenlik uyarıları için. Kampanya ve bülten e-postaları yalnızca izin vermeniz halinde gönderilir.",
          "Telefon numarası: Hesabınızı SMS doğrulama koduyla doğrulamak; kurye veya restoran adresinizi bulamadığında ya da adresinizi doğrulaması gerektiğinde sizi arayabilmesi ve siparişinizle ilgili acil durumlarda size ulaşabilmek için.",
          "Teslimat adresi ve adres konumu (adres açıklaması, adres tarifi/notu, şehir ve ilçe, haritada işaretlediğiniz enlem-boylam): Siparişinizi doğru adrese ulaştırmak, kuryenin adresinizi bulabilmesi ve bölgenize teslimat yapan restoranları gösterebilmek için.",
          "Cihaz konumu: Yalnızca adres eklerken \"konumumu kullan\" seçeneğine dokunmanız ve cihazınızdan izin vermeniz halinde, adresinizi haritada işaretlemek için tek seferlik olarak kullanılır. Arka planda konumunuz toplanmaz veya takip edilmez.",
          "Sipariş bilgileri (sipariş edilen ürünler, ürün ve sipariş notları, tutar, seçilen ödeme yöntemi, kullanılan promosyon kodu, sipariş tarihi ve durumu): Siparişinizi restorana iletmek, sipariş takibi, geçmiş siparişlerinizi ve yeniden sipariş özelliğini sunmak, şikayet ve itirazları çözmek ile yasal muhasebe yükümlülüklerini yerine getirmek için.",
          "Değerlendirme ve yorumlar: Siparişinizi puanladığınızda puanınız, yorumunuz ve adınız ilgili restorana iletilir; hizmet kalitesini artırmak için kullanılır.",
          "Canlı destek yazışmaları: Destek talebinizi çözmek ve hizmet kalitemizi geliştirmek için.",
          "Google ile giriş: Google hesabınızla giriş yaparsanız Google'ın bizimle paylaştığı ad, soyad ve e-posta adresiniz hesabınızı oluşturmak için kullanılır. Google şifrenize hiçbir şekilde erişmeyiz.",
          "Teknik veriler (Platformun oluşturduğu rastgele cihaz kimliği, oturum anahtarları, IP adresi, cihaz/tarayıcı türü, hata kayıtları): Oturumunuzu güvenli şekilde açık tutmak, yetkisiz erişim ve dolandırıcılığı önlemek ve teknik sorunları gidermek için.",
        ],
      },
      {
        heading: "3. Ödeme Bilgileri",
        paragraphs: [
          "Platform üzerinden kredi kartı, banka kartı veya banka hesap bilgisi toplamıyor ve saklamıyoruz. Ödeme, teslimat sırasında siparişi verdiğiniz restoranın sunduğu yöntemlerle restorana yapılır. Platformda yalnızca seçtiğiniz ödeme yöntemi (ör. nakit, kapıda kart) kaydedilir.",
        ],
      },
      {
        heading: "4. Verilerinizi Kimlerle Paylaşıyoruz",
        paragraphs: [
          "Kişisel verilerinizi satmıyor, kiralamıyor ve reklam amacıyla üçüncü kişilerle paylaşmıyoruz. Verileriniz yalnızca aşağıdaki durumlarda paylaşılır:",
        ],
        items: [
          "Sipariş verdiğiniz restoran ve kuryesi: Yalnızca siparişi verdiğiniz restoranla, yalnızca o siparişi hazırlamak ve teslim etmek için gerekli bilgiler paylaşılır: adınız soyadınız, telefon numaranız, teslimat adresiniz ve adres konumu, adres tarifiniz, sipariş içeriği ve notlarınız. Restoranlar yalnızca kendilerine verilen siparişlere ait bilgileri görebilir; verileriniz sipariş vermediğiniz restoranlarla paylaşılmaz. Restoranlar bu bilgileri yalnızca siparişinizi teslim etmek ve siparişle ilgili sizinle iletişim kurmak amacıyla kullanabilir.",
          "Hizmet sağlayıcılarımız: Platformun çalışması için yardım aldığımız sunucu/barındırma, SMS doğrulama, e-posta gönderimi ve harita/konum (Google Maps) ile Google ile giriş hizmeti sağlayıcıları. Bu sağlayıcılar verilerinize yalnızca bize hizmet vermek için gereken ölçüde erişebilir ve verilerinizi kendi amaçları için kullanamaz.",
          "Yasal yükümlülükler: Yürürlükteki mevzuat gereği veya yetkili kamu kurum ve kuruluşlarının, mahkemelerin talebi halinde.",
        ],
      },
      {
        heading: "5. Yurt Dışına Aktarım",
        paragraphs: [
          "Kullandığımız bazı hizmet sağlayıcıların (ör. Google) sunucuları Kuzey Kıbrıs dışında bulunabilir. Bu durumda verileriniz, yalnızca yukarıdaki amaçlarla ve uygun güvenlik önlemleri alınarak yurt dışındaki sunucularda işlenebilir.",
        ],
      },
      {
        heading: "6. Cihazınızda Saklanan Bilgiler",
        paragraphs: [
          "Platform, çalışabilmesi için cihazınızın tarayıcı/uygulama hafızasında (yerel depolama) dil tercihinizi, sepetinizi, seçtiğiniz şehir/ilçeyi ve oturum bilgilerinizi saklar. \"Beni hatırla\" seçeneğini işaretlerseniz giriş bilgileriniz şifrelenmiş olarak yalnızca cihazınızda tutulur. Reklam veya üçüncü taraf izleme çerezleri kullanmıyoruz.",
        ],
      },
      {
        heading: "7. Saklama Süreleri",
        items: [
          "Hesap bilgileriniz, kayıtlı adresleriniz ve tercihleriniz hesabınız açık olduğu sürece saklanır.",
          "Hesabınızı sildiğinizde kişisel verileriniz en geç 30 gün içinde sistemlerimizden silinir veya sizi tanımlayamayacak şekilde anonimleştirilir.",
          "Muhasebe ve vergi mevzuatı gereği saklanması zorunlu olan sipariş ve fatura kayıtları, ilgili mevzuatın öngördüğü süre boyunca erişimi kısıtlanarak saklanır ve süre sonunda silinir.",
          "Canlı destek yazışmaları ile güvenlik kayıtları, olası uyuşmazlıkların ve dolandırıcılık incelemelerinin çözülebilmesi için en fazla 1 yıl saklanır.",
        ],
      },
      {
        heading: "8. Veri Güvenliği",
        paragraphs: [
          "Platform ile sunucularımız arasındaki tüm veri iletimi HTTPS/TLS ile şifrelenir. Verilerinize erişim yetkili personelle sınırlıdır ve verilerinizi yetkisiz erişime, kayba ve kötüye kullanıma karşı korumak için makul teknik ve idari önlemler alınır. Hesap şifrenizi kimseyle paylaşmamanızı öneririz.",
        ],
      },
      {
        heading: "9. Yaş Sınırı",
        paragraphs: [
          `Platform ${MIN_USER_AGE} yaşından küçükler için tasarlanmamıştır ve ${MIN_USER_AGE} yaşından küçüklerin hesap oluşturmasına izin verilmez. ${MIN_USER_AGE}–18 yaş arasındaki kullanıcıların Platformu ebeveyn veya yasal vasilerinin bilgisi ve onayıyla kullanması gerekir. ${MIN_USER_AGE} yaşından küçük bir çocuğa ait veri topladığımızı fark edersek bu verileri derhal sileriz. Böyle bir durumdan haberdarsanız lütfen ${CONTACT_EMAIL} adresine bildirin.`,
        ],
      },
      {
        heading: "10. Haklarınız",
        paragraphs: [
          "Kuzey Kıbrıs Türk Cumhuriyeti Kişisel Verilerin Korunması Yasası (89/2007) ve uygulanabildiği ölçüde ilgili diğer veri koruma mevzuatı kapsamında aşağıdaki haklara sahipsiniz:",
        ],
        items: [
          "Hakkınızda kişisel veri işlenip işlenmediğini ve hangi verilerin işlendiğini öğrenme ve bunların bir kopyasını talep etme,",
          "Eksik veya yanlış verilerin düzeltilmesini isteme (çoğu bilginizi Profilim ve Adreslerim sayfalarından kendiniz güncelleyebilirsiniz),",
          "Verilerinizin silinmesini isteme ve hesabınızı silme,",
          "Kampanya ve bülten e-postalarını almayı durdurma (Profilim > E-posta Tercihleri),",
          "Verilerinizin işlenmesine itiraz etme ve yetkili veri koruma makamına şikayette bulunma.",
        ],
      },
      {
        heading: "11. Haklarınızı Nasıl Kullanırsınız",
        paragraphs: [
          `Taleplerinizi kayıtlı e-posta adresinizden ${CONTACT_EMAIL} adresine gönderebilirsiniz. Talebiniz kimliğiniz doğrulandıktan sonra en geç 30 gün içinde yanıtlanır.`,
          "Hesabınızı ve verilerinizi silmek için izlemeniz gereken adımlar [Hesap Silme](/hesap-silme) sayfasında anlatılmıştır.",
        ],
      },
      {
        heading: "12. Politika Değişiklikleri",
        paragraphs: [
          "Bu politikayı zaman zaman güncelleyebiliriz. Güncel sürüm her zaman bu sayfada yayınlanır ve sayfanın başındaki \"Son güncelleme\" tarihi değiştirilir. Önemli değişiklikleri e-posta veya Platform içi bildirimle ayrıca duyururuz.",
        ],
      },
    ],
  },

  terms: {
    title: "Kullanım Koşulları",
    intro: [
      "İşbu Kullanıcı Sözleşmesi (“Sözleşme”), www.mutfacik.com internet sitesi ve Mutfacık mobil uygulaması (“Platform”) üzerinden sunulan hizmetlerden yararlanan kullanıcı (“Kullanıcı”) ile aşağıda bilgileri yer alan işletme (“Mutfacık”) arasında düzenlenmiştir.",
    ],
    sections: [
      {
        heading: "1. Taraflar",
        paragraphs: ["İşletme ve iletişim bilgileri:"],
        items: [
          `Ticari unvan / işletme sahibi: ${BUSINESS_OWNER}`,
          `MŞ No: ${BUSINESS_REG_NO}`,
          `Adres: ${BUSINESS_ADDRESS}`,
          `E-posta: ${CONTACT_EMAIL}`,
          `Telefon: ${BUSINESS_PHONE}`,
          `İnternet sitesi: ${WEBSITE}`,
        ],
      },
      {
        heading: "2. Sözleşmenin Konusu ve Kapsamı",
        paragraphs: [
          "İşbu Sözleşme; Kullanıcı'nın Platform'a erişimi, üyelik oluşturması, sipariş vermesi ve Platform üzerinden sunulan hizmetlerden yararlanması sırasında tarafların hak ve yükümlülüklerini düzenler.",
          "Platform, çevrim içi yemek siparişi verilmesini, sipariş bilgilerinin iletilmesini ve sipariş süreçlerinin takip edilmesini sağlayabilir.",
          "Platform'un doğrudan satıcı veya restoranlarla müşterileri buluşturan bir aracı olarak faaliyet göstermesine göre tarafların sorumlulukları yürürlükteki mevzuat çerçevesinde belirlenir.",
        ],
      },
      {
        heading: "3. Üyelik ve Kullanıcı Bilgileri",
        items: [
          "3.1. Kullanıcı, üyelik oluştururken talep edilen bilgileri doğru, güncel ve eksiksiz olarak vermeyi kabul eder.",
          "3.2. Kullanıcı, hesabına ait giriş bilgilerinin güvenliğinden sorumludur. Hesabının yetkisiz kullanıldığını fark etmesi durumunda Mutfacık'a gecikmeden bildirimde bulunmalıdır.",
          "3.3. Kullanıcı, Platform'u yürürlükteki mevzuata ve işbu Sözleşme'ye uygun şekilde kullanmayı kabul eder.",
          "3.4. Sahte sipariş oluşturulması, ödeme sistemlerinin kötüye kullanılması veya Platform'un güvenliğini tehdit eden işlemlerin tespit edilmesi hâlinde, mevzuata uygun önlemler alınabilir.",
          `3.5. Platform'a üye olmak ve sipariş vermek için en az ${MIN_USER_AGE} yaşında olmak gerekir. 18 yaşından küçük Kullanıcılar Platform'u ebeveyn veya yasal vasilerinin bilgisi ve onayıyla kullanmalıdır. Yaş sınırlamasına tabi ürünler 18 yaşından küçüklere satılamaz.`,
        ],
      },
      {
        heading: "4. Sipariş Verme ve Onay",
        items: [
          "4.1. Kullanıcı, Platform'da sunulan ürünleri, fiyatları ve ürün açıklamalarını inceleyerek sipariş oluşturabilir.",
          "4.2. Sipariş öncesinde ürün bedeli, teslimat ücreti ve varsa diğer ücretler ile ödenecek toplam tutar Kullanıcı'ya gösterilir.",
          "4.3. Siparişin kabul edilmesi, ilgili işletmenin onayı veya Platform'da belirtilen sipariş onay sürecinin tamamlanmasıyla kesinleşir.",
          "4.4. Ürünlerin hazırlanması ve teslimatı, siparişin niteliğine ve ilgili işletmenin çalışma koşullarına göre gerçekleştirilir.",
          "4.5. Ürün fiyatlarında, menülerde ve stok durumlarında değişiklik olabilir. Sipariş onaylandıktan sonraki işlemlerde Kullanıcı'nın yasal hakları korunur.",
        ],
      },
      {
        heading: "5. Ödeme Koşulları",
        items: [
          "5.1. Kullanıcı, sipariş bedelini Platform'da sunulan ödeme yöntemlerinden biriyle öder.",
          "5.2. Ödeme yöntemleri, Platform'da sipariş sırasında belirtilen seçeneklerden oluşur.",
          "5.3. Platform üzerinden kart bilgisi alınmaz; ödeme, teslimat sırasında ilgili işletmenin sunduğu yöntemlerle (ör. nakit veya kapıda kart) yapılır. Platform'da ileride çevrim içi ödeme sunulması hâlinde, kartlı ödemeler ilgili ödeme hizmeti sağlayıcılarının altyapıları üzerinden gerçekleştirilir.",
          "5.4. Kullanıcı, kendisine ait olmayan bir ödeme aracını yetkisiz şekilde kullanamaz.",
          "5.5. Ödeme işleminin başarısız olması veya doğrulanamaması hâlinde sipariş tamamlanmayabilir. Bu durumda Kullanıcı bilgilendirilir.",
        ],
      },
      {
        heading: "6. Teslimat",
        items: [
          "6.1. Sipariş, Kullanıcı tarafından belirtilen adrese veya sipariş sırasında seçilen teslimat yöntemi üzerinden ulaştırılır.",
          "6.2. Kullanıcı, teslimat adresini ve iletişim bilgilerini doğru vermekle yükümlüdür.",
          "6.3. Teslimat süresi; sipariş yoğunluğu, trafik, hava koşulları ve hazırlık süresi gibi nedenlerden etkilenebilir.",
          "6.4. Teslimatın mümkün olmaması, siparişin eksik veya yanlış ulaşması ya da ürünün hasarlı olması durumunda Kullanıcı, destek kanallarından yardım talep edebilir.",
        ],
      },
      {
        heading: "7. Sipariş İptali, İade ve Şikâyetler",
        items: [
          "7.1. Kullanıcı, siparişini iptal etmek veya değişiklik talep etmek için Platform'daki ilgili araçları ya da müşteri destek kanallarını kullanabilir.",
          "7.2. Siparişin hazırlanmaya başlanmış olması veya teslimat sürecine girmesi, iptal işlemini etkileyebilir. Bununla birlikte Kullanıcı'nın yürürlükteki mevzuattan doğan hakları saklıdır.",
          "7.3. Eksik, yanlış, hasarlı veya siparişe uygun olmayan ürün teslim edilmesi durumunda Kullanıcı, durumu Mutfacık'a veya ilgili satıcıya bildirebilir.",
          "7.4. İptal ve ücret iadesi talepleri, siparişin durumu ve yürürlükteki mevzuat çerçevesinde değerlendirilir.",
          "7.5. Yiyecek ve içecek siparişlerinde, ürünün niteliğine ve ilgili mevzuata bağlı olarak cayma hakkı istisnaları uygulanabilir. Bu durum, ayıplı veya sözleşmeye aykırı ürünlere ilişkin yasal hakları ortadan kaldırmaz.",
        ],
      },
      {
        heading: "8. Kullanıcının Yükümlülükleri",
        paragraphs: ["Kullanıcı;"],
        items: [
          "Platform'u hukuka uygun amaçlarla kullanmayı,",
          "Gerçeğe aykırı veya kötüye kullanım amacı taşıyan siparişler oluşturmamayı,",
          "Başka kullanıcıların hesaplarına veya kişisel bilgilerine yetkisiz erişim sağlamamayı,",
          "Platform'un işleyişine zarar verecek girişimlerde bulunmamayı,",
          "Sipariş ve teslimat süreçleri için gerekli bilgileri doğru sağlamayı kabul eder.",
        ],
      },
      {
        heading: "9. Kişisel Verilerin Korunması ve Gizlilik",
        items: [
          "9.1. Kullanıcı'nın kişisel verileri, yürürlükteki kişisel verilerin korunması mevzuatına uygun olarak işlenir.",
          "9.2. Kişisel verilerin işlenmesine ilişkin amaçlar, hukuki sebepler, aktarım yapılan taraflar ve Kullanıcı'nın hakları hakkında ayrıntılı bilgi, Platform'da yayımlanan [Gizlilik Politikası](/gizlilik-politikasi)'nda belirtilir.",
          "9.3. Siparişin alınması, ödemenin gerçekleştirilmesi, teslimatın yapılması ve müşteri desteğinin sağlanması için gerekli veriler, ilgili mevzuata uygun şekilde işlenebilir.",
          "9.4. Ticari elektronik ileti gönderimleri, ilgili mevzuata uygun izin ve onay süreçleri çerçevesinde yürütülür.",
        ],
      },
      {
        heading: "10. Fikri Mülkiyet Hakları",
        paragraphs: [
          "Platform'da yer alan marka, logo, tasarım, metin, görsel, yazılım ve diğer içeriklere ilişkin haklar ilgili hak sahiplerine aittir. Bu içerikler, hak sahibinin izni veya mevzuatın izin verdiği hâller dışında kullanılamaz.",
        ],
      },
      {
        heading: "11. Hizmetin Sunulması ve Teknik Kesintiler",
        paragraphs: [
          "Mutfacık, Platform'un güvenli ve kullanılabilir durumda tutulması için makul çabayı gösterir. Bakım çalışmaları, teknik arızalar, internet bağlantısı sorunları veya kontrol dışındaki olaylar nedeniyle geçici kesintiler yaşanabilir.",
          "Bu hüküm, Mutfacık'ın kanunen sorumlu olduğu durumlarda yasal sorumluluklarını ortadan kaldırmaz.",
        ],
      },
      {
        heading: "12. Sorumlulukların Belirlenmesi",
        paragraphs: [
          "Mutfacık'ın doğrudan satıcı veya aracı platform olarak faaliyet göstermesine göre ürün, ödeme, teslimat ve tüketici taleplerine ilişkin sorumlulukları yürürlükteki mevzuata göre belirlenir.",
          "Ürünlerin hazırlanması, içeriği, hijyen koşulları ve teslimatına ilişkin sorumluluklar, ilgili işlemin taraflarına ve uygulanabilir mevzuata göre değerlendirilir.",
          "Hiçbir hüküm, Kullanıcı'nın emredici mevzuat kapsamındaki haklarını ortadan kaldıracak şekilde yorumlanamaz.",
        ],
      },
      {
        heading: "13. Sözleşmede Değişiklik",
        paragraphs: [
          "Mutfacık, hizmetlerinde veya mevzuatta meydana gelen değişiklikler nedeniyle Sözleşme'yi güncelleyebilir. Güncellenen metin Platform'da yayımlanır ve gerekli durumlarda Kullanıcı'ya bildirilir.",
        ],
      },
      {
        heading: "14. Sözleşmenin Sona Ermesi",
        paragraphs: [
          "Kullanıcı, üyeliğini sonlandırmak için Platform'da sunulan hesap kapatma yöntemlerini veya müşteri destek kanallarını kullanabilir. Ayrıntılar için [Hesap Silme](/hesap-silme) sayfasına bakınız.",
          "Sözleşmenin sona ermesi, daha önce doğmuş ödeme yükümlülüklerini, devam eden siparişlere ilişkin hakları veya mevzuat gereği saklanması gereken kayıtları kendiliğinden ortadan kaldırmaz.",
        ],
      },
      {
        heading: "15. Uyuşmazlıkların Çözümü",
        paragraphs: [
          "İşbu Sözleşme'nin uygulanmasından doğabilecek uyuşmazlıklarda Kuzey Kıbrıs Türk Cumhuriyeti mevzuatı esas alınır.",
          "Tüketici işlemlerinden kaynaklanan uyuşmazlıklarda, yürürlükteki mevzuata göre görevli ve yetkili tüketici koruma mercilerine ve mahkemelere başvurulabilir. Kullanıcı'nın yasal başvuru hakları saklıdır.",
        ],
      },
      {
        heading: "16. Yürürlük ve Kabul",
        paragraphs: [
          "Kullanıcı, üyelik oluşturma veya sözleşmenin kabulünü gerektiren bir işlem sırasında kendisine sunulan Sözleşme'yi inceleyebilir ve uygun onay mekanizması üzerinden kabul edebilir.",
        ],
      },
      {
        heading: "Mutfacık İletişim Bilgileri",
        items: [
          `İşletme sahibi: ${BUSINESS_OWNER}`,
          `MŞ No: ${BUSINESS_REG_NO}`,
          `Adres: ${BUSINESS_ADDRESS}`,
          `E-posta: ${CONTACT_EMAIL}`,
          `Telefon: ${BUSINESS_PHONE}`,
          `Web: ${WEBSITE}`,
        ],
      },
    ],
  },

  accountDeletion: {
    title: "Hesap ve Veri Silme",
    intro: [
      "Bu sayfa, Mutfacık (mutfacik.com ve Mutfacık mobil uygulaması) hesabınızı ve hesabınıza bağlı kişisel verilerinizi nasıl silebileceğinizi açıklar.",
    ],
    sections: [
      {
        heading: "1. Uygulama veya web sitesi üzerinden silme",
        items: [
          "Mutfacık uygulamasında veya mutfacik.com'da hesabınıza giriş yapın.",
          "Mobilde alt menüdeki \"Hesabım\" sekmesine, bilgisayarda üst kısımdaki menü (☰) düğmesine dokunun.",
          "\"Hesabımı Sil\" seçeneğine dokunun.",
          "\"Evet, Sil\" diyerek işlemi onaylayın. Hesabınız hemen kapatılır ve oturumunuz sonlandırılır.",
        ],
      },
      {
        heading: "2. Uygulamaya erişiminiz yoksa",
        paragraphs: [
          `Kayıtlı e-posta adresinizden ${CONTACT_EMAIL} adresine \"Hesap silme talebi\" konulu bir e-posta gönderin ve e-postada hesabınıza kayıtlı telefon numaranızı belirtin. Kimliğiniz doğrulandıktan sonra hesabınız en geç 30 gün içinde silinir ve size e-postayla bilgi verilir.`,
        ],
      },
      {
        heading: "3. Silinen veriler",
        items: [
          "Profil bilgileriniz: ad, soyad, doğum tarihi, e-posta adresi ve telefon numarası",
          "Şifreniz ve Google ile giriş bağlantınız",
          "Kayıtlı adresleriniz, adres tarifleriniz ve adres konumlarınız",
          "Favori restoranlarınız ve e-posta tercihleriniz",
          "Oturum ve cihaz kayıtlarınız",
          "Restoran değerlendirmelerinizdeki adınız (değerlendirmeler silinir veya sizinle ilişkisi kesilerek anonimleştirilir)",
        ],
      },
      {
        heading: "4. Saklanan veriler ve saklama süreleri",
        items: [
          "Muhasebe ve vergi mevzuatı gereği saklanması zorunlu olan sipariş ve fatura kayıtları, ilgili mevzuatın öngördüğü süre boyunca erişimi kısıtlanarak saklanır ve süre sonunda silinir.",
          "Canlı destek yazışmaları ve güvenlik kayıtları, olası uyuşmazlık ve dolandırıcılık incelemeleri için en fazla 1 yıl saklanır, ardından silinir.",
          "Silme işlemi tamamlandıktan sonra hesabınız geri getirilemez; Mutfacık'ı tekrar kullanmak için yeni bir hesap oluşturmanız gerekir.",
        ],
      },
      {
        heading: "5. Hesabı silmeden belirli verileri silme",
        paragraphs: [
          "Hesabınızı silmeden de kayıtlı adreslerinizi Adreslerim sayfasından silebilir, kampanya e-postalarını Profilim > E-posta Tercihleri bölümünden kapatabilirsiniz. Diğer verilerinizin silinmesi için " +
            `${CONTACT_EMAIL} adresine yazabilirsiniz. Ayrıntılar için [Gizlilik Politikası](/gizlilik-politikasi)'na bakınız.`,
        ],
      },
    ],
  },
};

const en: Record<LegalDocKey, LegalDoc> = {
  privacy: {
    title: "Privacy Policy",
    intro: [
      "Mutfacık (\"Mutfacık\", \"we\", \"us\") is a food ordering platform that lets you order from restaurants in Northern Cyprus through the mutfacik.com website and the Mutfacık mobile app (together, the \"Platform\").",
      "This Privacy Policy explains what personal data we collect, why we use it, who we share it with, how long we keep it and what rights you have. By using the Platform you acknowledge that you have been informed about the processing described in this policy.",
    ],
    sections: [
      {
        heading: "1. Data Controller and Contact",
        paragraphs: [
          `The controller of your personal data is ${BUSINESS_OWNER}, operating under the Mutfacık brand (Registration No: ${BUSINESS_REG_NO}, ${BUSINESS_ADDRESS}, Northern Cyprus).`,
          `For any privacy question or request: Email: ${CONTACT_EMAIL} · Phone: ${CONTACT_PHONE}`,
        ],
      },
      {
        heading: "2. Data We Collect and Why",
        paragraphs: [
          "We only collect the data we need to take your order, deliver it to you and keep your account secure:",
        ],
        items: [
          "First and last name: To create your account, show the restaurant and courier who the order belongs to, and recognise you at delivery.",
          `Date of birth: To verify that you meet the minimum age to use the Platform (${MIN_USER_AGE} or older) and to prevent age-restricted products from being sold to minors. Your date of birth is not shared with restaurants.`,
          "Email address: To sign in and verify your account; to send order confirmations and order status updates; to inform you if something goes wrong with your order (delay, cancellation, missing items, etc.); and for password resets and security alerts. Promotional emails and newsletters are only sent if you opt in.",
          "Phone number: To verify your account with an SMS code, and so that the courier or restaurant can call you if they cannot find your address, need to confirm it, or need to reach you urgently about your order.",
          "Delivery address and address location (address description, directions/notes, city and district, and the latitude/longitude you pin on the map): To deliver your order to the right place, help the courier find you, and show restaurants that deliver to your area.",
          "Device location: Used only once, when you tap \"use my location\" while adding an address and grant permission on your device, to pin your address on the map. We do not collect or track your location in the background.",
          "Order information (ordered items, item and order notes, amount, chosen payment method, promo code used, order date and status): To send your order to the restaurant, provide order tracking, order history and reordering, resolve complaints, and meet our legal accounting obligations.",
          "Ratings and reviews: When you rate an order, your score, comment and name are shared with that restaurant and used to improve service quality.",
          "Live support messages: To resolve your support requests and improve our service.",
          "Sign in with Google: If you sign in with Google, the name and email address Google shares with us are used to create your account. We never get access to your Google password.",
          "Technical data (a random device identifier generated by the Platform, session tokens, IP address, device/browser type, error logs): To keep your session secure, prevent unauthorised access and fraud, and fix technical problems.",
        ],
      },
      {
        heading: "3. Payment Information",
        paragraphs: [
          "We do not collect or store credit card, debit card or bank account details on the Platform. You pay the restaurant directly at delivery, using the payment methods that restaurant offers. The Platform only records which payment method you chose (e.g. cash, card on delivery).",
        ],
      },
      {
        heading: "4. Who We Share Your Data With",
        paragraphs: [
          "We do not sell or rent your personal data and we do not share it with third parties for advertising. Your data is shared only in the following cases:",
        ],
        items: [
          "The restaurant you order from and its courier: Only the restaurant you place an order with receives only what it needs to prepare and deliver that order: your name, phone number, delivery address and location, address directions, order contents and notes. Restaurants can only see data for orders placed with them; your data is never shared with restaurants you have not ordered from. Restaurants may use this information only to deliver your order and to contact you about it.",
          "Our service providers: Providers that help us run the Platform, such as server hosting, SMS verification, email delivery, maps/location (Google Maps) and Sign in with Google. They can access your data only as needed to provide their service to us and may not use it for their own purposes.",
          "Legal obligations: Where required by applicable law or requested by competent authorities or courts.",
        ],
      },
      {
        heading: "5. International Transfers",
        paragraphs: [
          "Some of our service providers (e.g. Google) may operate servers outside Northern Cyprus. In that case your data may be processed on servers abroad, only for the purposes above and with appropriate safeguards.",
        ],
      },
      {
        heading: "6. Information Stored on Your Device",
        paragraphs: [
          "To work, the Platform stores your language preference, basket, selected city/district and session information in your browser/app storage (local storage). If you tick \"Remember me\", your sign-in details are kept encrypted on your device only. We do not use advertising or third-party tracking cookies.",
        ],
      },
      {
        heading: "7. Data Retention",
        items: [
          "Your account details, saved addresses and preferences are kept for as long as your account is open.",
          "When you delete your account, your personal data is deleted from our systems or anonymised so it can no longer identify you within 30 days at the latest.",
          "Order and invoice records that we are legally required to keep under accounting and tax legislation are kept with restricted access for the period required by law and then deleted.",
          "Live support conversations and security logs are kept for up to 1 year so that disputes and fraud investigations can be resolved.",
        ],
      },
      {
        heading: "8. Data Security",
        paragraphs: [
          "All data transmitted between the Platform and our servers is encrypted with HTTPS/TLS. Access to your data is limited to authorised staff, and we take reasonable technical and organisational measures to protect it against unauthorised access, loss and misuse. Please do not share your account password with anyone.",
        ],
      },
      {
        heading: "9. Age Requirement",
        paragraphs: [
          `The Platform is not intended for children under ${MIN_USER_AGE}, and users under ${MIN_USER_AGE} may not create an account. Users aged ${MIN_USER_AGE}–18 must use the Platform with the knowledge and consent of a parent or legal guardian. If we learn that we have collected data from a child under ${MIN_USER_AGE}, we will delete it promptly. If you become aware of such a case, please contact ${CONTACT_EMAIL}.`,
        ],
      },
      {
        heading: "10. Your Rights",
        paragraphs: [
          "Under the TRNC Personal Data Protection Law (89/2007) and, where applicable, other data protection laws, you have the right to:",
        ],
        items: [
          "Find out whether and which personal data about you is processed, and request a copy,",
          "Request correction of incomplete or inaccurate data (you can update most of it yourself on the My Profile and My Addresses pages),",
          "Request deletion of your data and delete your account,",
          "Stop receiving promotional emails and newsletters (My Profile > Email Preferences),",
          "Object to the processing of your data and lodge a complaint with the competent data protection authority.",
        ],
      },
      {
        heading: "11. How to Exercise Your Rights",
        paragraphs: [
          `Send your request from your registered email address to ${CONTACT_EMAIL}. We will respond within 30 days at the latest after verifying your identity.`,
          "The steps for deleting your account and data are described on the [Account Deletion](/hesap-silme) page.",
        ],
      },
      {
        heading: "12. Changes to This Policy",
        paragraphs: [
          "We may update this policy from time to time. The current version is always published on this page and the \"Last updated\" date at the top is changed. We will also announce material changes by email or in-app notice.",
        ],
      },
    ],
  },

  terms: {
    title: "Terms of Use",
    intro: [
      "This User Agreement (the “Agreement”) is made between the user (the “User”) of the services offered through the www.mutfacik.com website and the Mutfacık mobile app (the “Platform”) and the business whose details are given below (“Mutfacık”).",
    ],
    sections: [
      {
        heading: "1. Parties",
        paragraphs: ["Business and contact details:"],
        items: [
          `Trade name / business owner: ${BUSINESS_OWNER}`,
          `Registration No (MŞ No): ${BUSINESS_REG_NO}`,
          `Address: ${BUSINESS_ADDRESS}, Northern Cyprus`,
          `Email: ${CONTACT_EMAIL}`,
          `Phone: ${BUSINESS_PHONE}`,
          `Website: ${WEBSITE}`,
        ],
      },
      {
        heading: "2. Subject and Scope",
        paragraphs: [
          "This Agreement sets out the rights and obligations of the parties when the User accesses the Platform, creates an account, places orders and uses the services offered through the Platform.",
          "The Platform may enable online food ordering, the transmission of order details and the tracking of orders.",
          "The parties' responsibilities are determined under applicable law, depending on whether the Platform acts as a direct seller or as an intermediary connecting restaurants with customers.",
        ],
      },
      {
        heading: "3. Account and User Information",
        items: [
          "3.1. The User agrees to provide accurate, up-to-date and complete information when creating an account.",
          "3.2. The User is responsible for keeping their login details secure and must notify Mutfacık without delay if they notice any unauthorised use of their account.",
          "3.3. The User agrees to use the Platform in accordance with applicable law and this Agreement.",
          "3.4. If fake orders, misuse of payment systems or actions threatening the security of the Platform are detected, measures may be taken in accordance with the law.",
          `3.5. You must be at least ${MIN_USER_AGE} years old to register and place orders. Users under 18 must use the Platform with the knowledge and consent of a parent or legal guardian. Age-restricted products cannot be sold to anyone under 18.`,
        ],
      },
      {
        heading: "4. Placing and Confirming Orders",
        items: [
          "4.1. The User may place an order after reviewing the products, prices and product descriptions offered on the Platform.",
          "4.2. Before ordering, the User is shown the product price, delivery fee, any other charges and the total amount payable.",
          "4.3. An order becomes final once the relevant business accepts it or the order confirmation process described on the Platform is completed.",
          "4.4. Products are prepared and delivered according to the nature of the order and the working conditions of the relevant business.",
          "4.5. Prices, menus and stock availability may change. The User's statutory rights are protected for orders that have already been confirmed.",
        ],
      },
      {
        heading: "5. Payment",
        items: [
          "5.1. The User pays for the order using one of the payment methods offered on the Platform.",
          "5.2. The available payment methods are those shown on the Platform when ordering.",
          "5.3. No card details are collected on the Platform; payment is made at delivery using the methods offered by the relevant business (e.g. cash or card on delivery). If online payment is offered on the Platform in the future, card payments will be processed through the infrastructure of the relevant payment service providers.",
          "5.4. The User may not use a payment instrument that does not belong to them without authorisation.",
          "5.5. If a payment fails or cannot be verified, the order may not be completed. In that case the User will be informed.",
        ],
      },
      {
        heading: "6. Delivery",
        items: [
          "6.1. The order is delivered to the address provided by the User or through the delivery method chosen when ordering.",
          "6.2. The User is responsible for providing an accurate delivery address and contact details.",
          "6.3. Delivery times may be affected by order volume, traffic, weather and preparation time.",
          "6.4. If delivery is not possible, or if the order arrives incomplete, incorrect or damaged, the User may ask for help through the support channels.",
        ],
      },
      {
        heading: "7. Cancellations, Refunds and Complaints",
        items: [
          "7.1. To cancel or change an order, the User may use the relevant tools on the Platform or the customer support channels.",
          "7.2. Cancellation may be affected if the order is already being prepared or is out for delivery. The User's statutory rights remain reserved.",
          "7.3. If incomplete, incorrect, damaged or non-conforming products are delivered, the User may report this to Mutfacık or to the relevant seller.",
          "7.4. Cancellation and refund requests are assessed according to the status of the order and applicable law.",
          "7.5. For food and drink orders, exceptions to the right of withdrawal may apply depending on the nature of the product and applicable law. This does not remove the User's statutory rights regarding defective or non-conforming products.",
        ],
      },
      {
        heading: "8. User Obligations",
        paragraphs: ["The User agrees to:"],
        items: [
          "Use the Platform for lawful purposes,",
          "Not place false or abusive orders,",
          "Not gain unauthorised access to other users' accounts or personal information,",
          "Not attempt to harm the operation of the Platform,",
          "Provide accurate information needed for ordering and delivery.",
        ],
      },
      {
        heading: "9. Personal Data and Privacy",
        items: [
          "9.1. The User's personal data is processed in accordance with applicable data protection law.",
          "9.2. Detailed information on the purposes and legal grounds of processing, the parties data is shared with and the User's rights is set out in the [Privacy Policy](/gizlilik-politikasi) published on the Platform.",
          "9.3. Data needed to receive the order, process payment, deliver the order and provide customer support may be processed in accordance with applicable law.",
          "9.4. Commercial electronic messages are sent only with the consent required by applicable law.",
        ],
      },
      {
        heading: "10. Intellectual Property",
        paragraphs: [
          "Rights to the trademarks, logos, designs, texts, images, software and other content on the Platform belong to their respective owners. This content may not be used without the owner's permission except where permitted by law.",
        ],
      },
      {
        heading: "11. Service Availability and Technical Interruptions",
        paragraphs: [
          "Mutfacık makes reasonable efforts to keep the Platform secure and available. Temporary interruptions may occur due to maintenance, technical faults, internet connection problems or events outside its control.",
          "This clause does not remove Mutfacık's statutory liability where it is legally responsible.",
        ],
      },
      {
        heading: "12. Allocation of Responsibilities",
        paragraphs: [
          "Mutfacık's responsibilities regarding products, payments, delivery and consumer requests are determined under applicable law, depending on whether it acts as a direct seller or as an intermediary platform.",
          "Responsibilities regarding the preparation, ingredients, hygiene and delivery of products are assessed according to the parties to the relevant transaction and applicable law.",
          "Nothing in this Agreement may be interpreted to limit the User's rights under mandatory law.",
        ],
      },
      {
        heading: "13. Changes to the Agreement",
        paragraphs: [
          "Mutfacık may update this Agreement due to changes in its services or in the law. The updated text is published on the Platform and the User is notified where necessary.",
        ],
      },
      {
        heading: "14. Termination",
        paragraphs: [
          "The User may close their account using the account deletion options on the Platform or through customer support. See the [Account Deletion](/hesap-silme) page for details.",
          "Termination does not by itself cancel payment obligations that have already arisen, rights relating to ongoing orders, or records that must be kept by law.",
        ],
      },
      {
        heading: "15. Dispute Resolution",
        paragraphs: [
          "Disputes arising from the performance of this Agreement are governed by the laws of the Turkish Republic of Northern Cyprus.",
          "For disputes arising from consumer transactions, the User may apply to the competent consumer protection authorities and courts under applicable law. The User's statutory rights of recourse remain reserved.",
        ],
      },
      {
        heading: "16. Entry into Force and Acceptance",
        paragraphs: [
          "The User can review this Agreement when it is presented during registration or any other action requiring its acceptance, and can accept it through the relevant consent mechanism.",
        ],
      },
      {
        heading: "Mutfacık Contact Details",
        items: [
          `Business owner: ${BUSINESS_OWNER}`,
          `Registration No (MŞ No): ${BUSINESS_REG_NO}`,
          `Address: ${BUSINESS_ADDRESS}, Northern Cyprus`,
          `Email: ${CONTACT_EMAIL}`,
          `Phone: ${BUSINESS_PHONE}`,
          `Web: ${WEBSITE}`,
        ],
      },
    ],
  },

  accountDeletion: {
    title: "Account and Data Deletion",
    intro: [
      "This page explains how to delete your Mutfacık account (mutfacik.com and the Mutfacık mobile app) and the personal data linked to it.",
    ],
    sections: [
      {
        heading: "1. Delete from the app or website",
        items: [
          "Sign in to your account in the Mutfacık app or on mutfacik.com.",
          "On mobile, tap \"Account\" in the bottom menu; on desktop, open the menu (☰) at the top of the page.",
          "Tap \"Delete Account\".",
          "Confirm with \"Yes, Delete\". Your account is closed immediately and you are signed out.",
        ],
      },
      {
        heading: "2. If you cannot access the app",
        paragraphs: [
          `Send an email with the subject \"Account deletion request\" from your registered email address to ${CONTACT_EMAIL}, including the phone number registered to your account. After verifying your identity, we will delete your account within 30 days at the latest and confirm by email.`,
        ],
      },
      {
        heading: "3. Data that is deleted",
        items: [
          "Your profile: first and last name, date of birth, email address and phone number",
          "Your password and Sign in with Google link",
          "Your saved addresses, directions and address locations",
          "Your favourite restaurants and email preferences",
          "Your session and device records",
          "Your name on restaurant reviews (reviews are deleted or anonymised so they are no longer linked to you)",
        ],
      },
      {
        heading: "4. Data that is kept and for how long",
        items: [
          "Order and invoice records that we are legally required to keep under accounting and tax legislation are kept with restricted access for the period required by law and then deleted.",
          "Live support conversations and security logs are kept for up to 1 year for dispute and fraud investigations, then deleted.",
          "Once deletion is complete your account cannot be restored; you will need to create a new account to use Mutfacık again.",
        ],
      },
      {
        heading: "5. Deleting some data without deleting your account",
        paragraphs: [
          "Without deleting your account, you can remove saved addresses on the My Addresses page and turn off promotional emails under My Profile > Email Preferences. To have other data deleted, " +
            `write to ${CONTACT_EMAIL}. See the [Privacy Policy](/gizlilik-politikasi) for details.`,
        ],
      },
    ],
  },
};

export const legalContent: Record<Language, Record<LegalDocKey, LegalDoc>> = { tr, en };
